import EventHandler from '@pixelunion/events';
import * as breakpoint from '@pixelunion/breakpoint';
import SearchFlyout from '../components/SearchFlyout';
import NavDesktopMenu from '../components/NavDesktopMenu';
import NavMobile from '../components/NavMobile';
import PredictiveSearch from '../components/PredictiveSearch';

export default class StaticHeader {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.events = new EventHandler();

    this.announcementBar = document.querySelector('.pxs-announcement-bar');
    this.headerControls = document.querySelector('[data-header-controls]');
    this.header = this.el.querySelector('[data-site-header]');
    this.headerContainer = this.el.querySelector('[data-site-header-container]');
    this.siteOverlay = document.querySelector('[data-site-overlay]');
    this.logo = this.el.querySelector('[data-header-logo]');
    this.sticky = this.data.sticky_header;

    this.search = this.el.querySelector('[data-search-trigger]');
    this.searchForm = this.el.querySelector('[data-search-form]');
    this.searchFlyoutEl = this.el.querySelector('[data-search-flyout]');
    this.searchFlyout = new SearchFlyout(this.searchFlyoutEl, this.data);

    this.enablePredictiveSearch = this.data.enable_predictive_search;

    this.navigation = this.el.querySelector('[data-navigation-desktop]');
    this.mobileNav = this.el.querySelector('[data-mobile-nav]');

    // We need to move the mobile nav in the dom to be outside of the header to allow for
    // appropriate z-index between the header controls, header, and mobile nav.
    this.mobileNav = document.body.insertBefore(this.mobileNav, this.el.nextSibling);

    this.navDesktopMenu = new NavDesktopMenu(this.navigation);

    this.navMobile = new NavMobile({
      controls: this.headerControls,
      mobileNav: this.mobileNav,
    });

    document.body.style.setProperty('--scroll-away-opacity', 1);

    // This is the logo height plus the announcement bar height to have the
    // scroll away opacity effect work better with images taller than 100px.
    // We also need to adjust the fade slightly because the logo does not
    // scroll completely away (10px).
    const barHeight = this.announcementBar ? this.announcementBar.getBoundingClientRect().height : 0;
    const fadeHeight = Math.max(this.logo.getBoundingClientRect().height + barHeight - 10, 100);
    document.documentElement.style.setProperty('--announcement-bar-height', `${barHeight}px`);

    if (this.enablePredictiveSearch === 'true') {
      this.predictiveSearch = new PredictiveSearch(this.searchForm);
    }

    this.events.register(window, 'scroll', () => {
      const opacity = Math.max(1 - (window.scrollY / fadeHeight), 0);
      document.body.style.setProperty('--scroll-away-opacity', opacity);

      const searchBottom = this.search.getBoundingClientRect().bottom;
      const navigationTop = this.navigation.getBoundingClientRect().top;
      const siteHeaderTop = this.header.getBoundingClientRect().top;
      const scrollHitbox = breakpoint.max('M') ? siteHeaderTop : navigationTop;

      if (this.sticky === 'true') {
        if (searchBottom > scrollHitbox) {
          this.searchFlyoutEl.classList.add('search-flyout--sticky');
        } else {
          this.searchFlyoutEl.classList.remove('search-flyout--sticky');
        }
      }
    });

    this.events.register(this.search, 'click', () => {
      if (this.sticky === 'true' && breakpoint.max('M')) {
        // Increase the z-index of the site overlay to hide the sticky header
        this.siteOverlay.style.zIndex = '900';
      } else if (this.sticky === 'true') {
        // Increase the z-index of the header container to hide the controls
        this.headerContainer.style.zIndex = '901';
      }

      this.searchFlyout._open();
    });
  }

  onSectionBlockSelect(block) {
    this.navDesktopMenu.selectBlock(block.id);
  }

  onSectionBlockDeselect() {
    this.navDesktopMenu.closeAllMenus();
  }

  onSectionUnload() {
    this.navDesktopMenu.unload();
    this.navMobile.unload();
    this.events.unregisterAll();
  }
}
